import { Country } from "@app/models/Country";
import { State } from "@app/models/State";
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CountryAndStateApi extends HOAApiBase {

    constructor() {
        super("CountryAndStateApi");
    }

    public getAllCountries(): Observable<{ data: Country[] }> {
        return this.http.get<{ data: Country[] }>(this.createUrl("HOAPass", '/countries/countries'));
    }

    public getAllStates(): Observable<{ data: State[] }> {
        return this.http.get<{ data: State[] }>(this.createUrl("HOAPass", '/states/states'));
    }

}


